import { inject } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import type { Store } from "../../../../client/stores";
import { mediaServerCatalogImage } from "../../../../client/utils";
import type { PodcastFragment } from "../../generated/webapi.g";
import { placeholderImage, PodcastSizes, PodcastSrcSet, Sizes, SrcSet } from "../../lib/image";
import { ImageTile } from "../../ui";

export interface PodcastTileProps {
    host: string;
    podcast: PodcastFragment;
    context?: string;
    store?: Store;
}

export const PodcastTile = inject("store")((props: PodcastTileProps) => {
    if (!props.store) {
        return null;
    }
    const { t } = useTranslation();
    const img = mediaServerCatalogImage(props.host, "podcast", props.podcast.id, 48, 48, true);
    const srcset: SrcSet[] = PodcastSrcSet(img);
    const sizes: Sizes[] = PodcastSizes();
    const placeholderSrcset: SrcSet[] = PodcastSrcSet(placeholderImage);
    const podcastProps = {
        title: props.podcast.title,
        url: `${props.store.env.NATIONAL_SITE_URL}/podcast/${props.podcast.slug}-${props.podcast.id}/`,
        imageUrl: `${img}?ops=max(270,270),quality(70)`,
        responsiveImg: {
            src: `${img}?ops=max(270,270),quality(70)`,
            alt: t("podcast_alt", { title: props.podcast.title }),
            srcset,
            sizes,
            placeholderSrcset,
            initialWidth: 150,
            initialHeight: 150,
        },
        context: props.context,
    };
    return <ImageTile {...podcastProps} />;
});

export default PodcastTile;
